export const SESSION_STORAGE = {
  rpsQuoteId: 'rpsQuoteId',
  oldRpsQuoteId: 'oldRpsQuoteId',
  contextSelectedArray: 'contextSelectedArray',
  NPAAgentContextID: 'NPA_AgentContextID',
  NPANavigationClientContext: 'NPA_NavigationClientContext',
  NPALeadsContext: 'NPA_LeadsContext',
  globalContext: 'globalContext',
} as const
